import { API_URL } from '../../env';
const baseUri = `${API_URL}/api/v1/assets`;
const AssetImage = ( { name } ) => {
    return (
        <img style={{maxHeight: '75px'}} alt={`for ${name}`} src={`${baseUri}/file/${name}`} />
    );
};

export { AssetImage };